import React from 'react';
import { ProFormItem } from '@ant-design/pro-components';
import ImageUpload from '../ImageUpload';

interface ProFormImageUploadProps {
    name: string;
    label?: string;
    tooltip?: string;
    rules?: any[];
    folder?: string;
    maxSize?: number;
    accept?: string;
    disabled?: boolean;
    placeholder?: string;
    // ProFormItem doesn't support colProps (that's a ProFormField-level prop,
    // used inside <ProForm grid>) - accepted here for caller compatibility
    // but intentionally not forwarded; it was already a no-op at runtime.
    colProps?: any;
}

const ProFormImageUpload: React.FC<ProFormImageUploadProps> = ({
    name,
    label,
    tooltip,
    rules = [],
    folder = 'brands',
    maxSize = 5,
    accept = 'image/*',
    disabled = false,
    placeholder = 'Chọn ảnh để upload',
    colProps: _colProps,
    ...rest
}) => {
    return (
        <ProFormItem
            name={name}
            label={label}
            tooltip={tooltip}
            rules={rules}
            {...rest}
        >
            <ImageUpload
                folder={folder}
                maxSize={maxSize}
                accept={accept}
                disabled={disabled}
                placeholder={placeholder}
            />
        </ProFormItem>
    );
};

export default ProFormImageUpload;
